import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import ScheduleCallFAB from "./components/ScheduleCallFAB";
import RequireAuth from "./components/RequireAuth";
import Home from "./pages/Home";
import Submit from "./pages/Submit";
import Compare from "./pages/Compare";
import Attorneys from "./pages/Attorneys";
import AttorneysPremium from "./pages/AttorneysPremium";
import AttorneyProfile from "./pages/AttorneyProfile";
import Concierge from "./pages/Concierge";
import Enterprise from "./pages/Enterprise";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import AttorneyJoin from "./pages/AttorneyJoin";

import CustomerLogin from "./pages/portal/CustomerLogin";
import CustomerDashboard from "./pages/portal/CustomerDashboard";
import AttorneyLogin from "./pages/firm/AttorneyLogin";
import AttorneyDashboard from "./pages/firm/AttorneyDashboard";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/attorneys" element={<Attorneys />} />
          <Route path="/attorneys/premium" element={<AttorneysPremium />} />
          <Route path="/attorneys/join" element={<AttorneyJoin />} />
          <Route path="/attorneys/:id" element={<AttorneyProfile />} />
          <Route path="/concierge" element={<Concierge />} />
          <Route path="/enterprise" element={<Enterprise />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/portal/login" element={<CustomerLogin />} />
          <Route path="/portal" element={<RequireAuth role="customer" loginPath="/portal/login"><CustomerDashboard /></RequireAuth>} />
          <Route path="/firm/login" element={<AttorneyLogin />} />
          <Route path="/firm" element={<RequireAuth role="attorney" loginPath="/firm/login"><AttorneyDashboard /></RequireAuth>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAuth role="admin" loginPath="/admin/login"><AdminDashboard /></RequireAuth>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ConditionalFAB />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

function ConditionalFAB() {
  const { pathname } = useLocation();
  const hideOn = ["/portal", "/firm", "/admin"];
  if (hideOn.some((p) => pathname === p || pathname.startsWith(p + "/"))) return null;
  return <ScheduleCallFAB />;
}

export default App;
